import { Operation } from '@occc-app/offerHelpers/types';
import { ConstraintConfigurationInput, ConstraintUpdateMutationVariables } from '@occc/graphql';
import { makeRequiresActivationConstraintConfiguration } from '@occc-app/offerHelpers/operations/makeRequiresActivationConstraintConfiguration';

export type UpdateConstraintOperationType = Operation<
  'constraintUpdate',
  ConstraintUpdateMutationVariables
>;

export const makeUpdateConstraint = (
  configurationId: string,
  configuration: ConstraintConfigurationInput,
): UpdateConstraintOperationType => {
  return {
    name: 'constraintUpdate',
    variables: {
      input: {
        id: configurationId,
        configuration,
      },
    },
  };
};

export const makeUpdateRequiresActivationConstraintOperation = (
  configurationId: string,
  allowMultipleFulfillmentsOnActivation: boolean,
  mustFulfillWithinDays?: number,
): UpdateConstraintOperationType => {
  const configuration = makeRequiresActivationConstraintConfiguration(
    allowMultipleFulfillmentsOnActivation,
    mustFulfillWithinDays,
  );

  return makeUpdateConstraint(configurationId, configuration);
};
